
LN.Wcentrix = new (function (Config) {
    'use strict';

    this.initChat = function (page) {
        $(document).ready(function () {
            if (Config.idWcentrix) {
                setTimeout(function () {
                    var s;
                    if (window.innerWidth >= 767) {
                        console.log('initWc');
                        s = document.createElement("script");
                        s.defer = true;
                        s.src = "https://wcentrix.net/tabhelp/wctabs.aspx?id=" + Config.idWcentrix + "&" + (new Date).getTime(), document.head.appendChild(s);
                    }
                }, Config.wCentrixTime);
            }
        });
    }

})(LN.Config);


// WEBPACK FOOTER //
// ./Statics/scripts/common/wcentrix.js